import { css } from '@emotion/react';
// Constants
import { ColorSAP } from "../../constants/Colors";

export const useStyles = () => ({
    functionBoxContainer: css({
        position: 'relative',
        cursor: 'pointer',
        boxSizing: "border-box",
        padding: 16,
        width: "100%",
        background: 'white',
        height: 110,
        borderRadius: 12,
        backgroundClip: 'padding-box',
        border: '2px solid transparent',
        transition: 'all ease-in-out 400ms',
        '&:before': {
            content: "''",
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: -1,
            margin: '-2px',
            borderRadius: 'inherit',
            background: `linear-gradient(to bottom, ${ColorSAP.primary[80]}, ${ColorSAP.primary[70]})`,
        },
        "&:hover": {
            borderRadius: 12,
            border: `2px solid ${ColorSAP.primary[70]}`,
            background: ColorSAP.primary[70],
        },
        "&:active": {
            border: `2px solid ${ColorSAP.primary[80]}`,
            background: ColorSAP.primary[80],
            transition: 'none',
        }
    }),
    functionBoxIconLabelDefault: css({
        display: 'flex',
        justifyContent: 'space-between',
        "& svg": {
            width: 32,
            height: 32,
            color: ColorSAP.primary[70],
            transition: "all .3s ease-in-out",
        }
    }),
    functionBoxIconLabelHovered: css({
        display: 'flex',
        justifyContent: 'space-between',
        "& svg": {
            width: 32,
            height: 32,
            color: ColorSAP.neutral[0],
            transition: "all .3s ease-in-out",
        }
    }),
    functionBoxChipContainer: css({
        display: 'flex',
        alignItems: 'center'
    }),
    functionBoxCollectionIcon: css({
        position: 'absolute',
        cursor: 'pointer',
        top: 12,
        right: 12,
        width: 32,
        height: 32,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }),
    functionBoxCollectionIconDefault: css({
        background: 'transparent',
        transition: '0.3s all ease',
        "& svg": {
            width: 24,
            height: 24,
            color: ColorSAP.primary[40]
        }
    }),
    functionBoxCollectionIconHovered: css({
        background: ColorSAP.primary[100],
        transition: '0.3s all ease',
        "& svg": {
            width: 24,
            height: 24,
            color: ColorSAP.primary[70]
        }
    }),
    functionBoxAddedToCollectionIconDefault: css({
        background: 'transparent',
        transition: '0.3s all ease',
        "& svg": {
            width: 24,
            height: 24,
            color: ColorSAP.secondary[70]
        }
    }),
    functionBoxAddedToCollectionIconHovered: css({
        background: ColorSAP.primary[100],
        transition: '0.3s all ease',
        "& svg": {
            width: 24,
            height: 24,
            color: ColorSAP.secondary[70]
        }
    }),
    functionBoxTypography: css({
        width: 'fit-content',
        cursor: 'pointer',
        letterSpacing: -0.53,
        transition: "all .2s ease-in-out",
        marginLeft: 6,
    })
});
